import { Typography } from "@mui/material";
import { useContext } from "react";
import { Box, FlexColBox } from "../../../../common/components";
import { Trans, useTranslation } from "react-i18next";
import { PreOrderPaymentOptions } from "../../../../types";
import { MaterialSymbolType } from "../../../../common/components/Icon/IconConstant";
import { CheckoutForm } from "../../Cart";
import { FormContext } from "../../../../context";
import SelectableBox from "../../../../common/components/Box/SelectableBox";
import { CheckoutStyles } from "../styles";
import { palette } from "../../../../styles/theme";

const iconToPaymentOption: Record<PreOrderPaymentOptions, MaterialSymbolType> =
  {
    [PreOrderPaymentOptions.BANK_TRANSFER]: "account_balance",
    [PreOrderPaymentOptions.CREDIT_CARD]: "credit_card",
    [PreOrderPaymentOptions.INTERAC_E_TRANSFER]: "send_to_mobile",
    [PreOrderPaymentOptions.CHEQUE]: "checkbook",
    [PreOrderPaymentOptions.NOT_SET]: "indeterminate_question_box",
  };

const CartCheckoutPaymentOptions = () => {
  const { t } = useTranslation();
  const { formik } = useContext(FormContext);
  const { paymentOption } = formik?.values as CheckoutForm;
  return (
    <FlexColBox sx={CheckoutStyles.container}>
      <FlexColBox gap={1}>
        <Typography variant="h2">
          {t("checkout.payment_options.title")}
        </Typography>
        <Typography variant="textSm">
          {t("checkout.payment_options.description")}
        </Typography>
      </FlexColBox>
      <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
        {Object.values(PreOrderPaymentOptions).map((option) => (
          <SelectableBox
            key={option}
            onClick={() => formik?.setFieldValue("paymentOption", option)}
            startIcon={iconToPaymentOption[option]}
            text={
              <Trans
                i18nKey={`checkout.payment_options.${option}`}
                components={{
                  1: (
                    <Typography variant="textXs" color={palette.grey.primary} />
                  ),
                }}
              />
            }
            active={option === paymentOption}
          />
        ))}
      </Box>
    </FlexColBox>
  );
};

export default CartCheckoutPaymentOptions;
